import { createFileRoute } from '@tanstack/react-router'
import * as Sentry from '@sentry/react'
import { signOut } from '@/lib/auth-client'
import { clearAuthData } from '@/lib/auth'
import { trackEvent } from '@/lib/posthog'
import { useEffect, useRef } from 'react'

export const Route = createFileRoute('/(auth)/logout')({
  component: RouteComponent,
})

function RouteComponent() {
  const loggedOut = useRef(false)

  useEffect(() => {
    if (loggedOut.current) return
    loggedOut.current = true

    const performLogout = async () => {
      console.log('>>> Starting logout process')

      try {
        trackEvent('auth.logout', { timestamp: new Date().toISOString() })
      } catch {}

      // Clear Sentry identity so future errors aren't attributed to the
      // signed-out user.
      try {
        Sentry.setUser(null)
        Sentry.setContext('organization', null)
        Sentry.setContext('workspace', null)
      } catch {}

      try {
        // signOut() handles: server session invalidation, cookie clearing,
        // extension sync, AND clearAuthData() (in that order)
        await signOut()
      } catch (error) {
        console.error('Server sign-out failed:', error)
        // Even if signOut failed, clear client state as fallback
        await clearAuthData()
      }

      // Always redirect — full page reload resets all React/Jotai/QueryClient state
      window.location.href = '/login?logout=true'
    }

    performLogout()
  }, [])

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="text-lg">Signing out...</div>
      </div>
    </div>
  )
}
